import React from 'react'
import './style.scss'
import { Routes, Route } from 'react-router-dom'
import NavBar from '../../components/NavBar/Search'
import Basic from './Basic/Index'
import Advance from './Advance/Index'
// import FourOFour from '../FourOfour/Index'
import Result from './Result/Index'

const Master = () => {
    return (
        <div className="search-master">
            <NavBar />
            <Routes>
                <Route path="/" element={<Basic />} />
                <Route path="advance" element={<Advance />} />
                <Route path="results" element={<Result />} />

                {/* <Route path="*" element={<FourOFour />} /> */}
            </Routes>

        </div>
    );
};

export default Master;